<template>
  <div v-if="result && result?.items?.length > 0" class="same-goods">
    <h3 v-if="result.messages && result.messages.title" class="def-header-3">
      {{ result.messages.title }}
    </h3>
    <DefSliderWrapper v-if="screenWidth >= 992">
      <Swiper
        :modules="modules"
        :slides-per-view="4"
        :space-between="4"
        :pagination="{ clickable: true }"
        navigation
      >
        <SwiperSlide v-for="(item, i) in result.items" :key="i">
          <SliderCard :result="item" />
        </SwiperSlide>
      </Swiper>
    </DefSliderWrapper>
    <PerfectScrollbar v-else class="same-goods__mobile">
      <SliderCard v-for="(item, i) in result.items" :key="i" :result="item" />
    </PerfectScrollbar>
  </div>
</template>

<script>
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import DefSliderWrapper from '@components/sliders/DefSliderWrapper.vue';
import { screenWidth } from '@use/useDeviceInfo';
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import SliderCard from '@components/card/SliderCard/SliderCard.vue';
import { mapState } from 'vuex';

export default {
  name: 'SameGoods',
  components: {
    SliderCard,
    DefSliderWrapper,
    Swiper,
    SwiperSlide,
    PerfectScrollbar,
  },
  data() {
    return {
      modules: [Navigation, Pagination],
      screenWidth,
    };
  },
  computed: {
    ...mapState({
      result: ({ product }) => product.data?.product?.siblings,
    }),
  },
};
</script>

<style lang="scss">
.same-goods {
  margin: 24px 0;
  @include point-md {
    margin: 24px 0;
  }
  @include point-lg {
    margin: 48px 0;
  }
  &__mobile {
    display: flex;
    overflow-x: auto;
    padding-bottom: 20px;
    & > * {
      width: 236px;
      flex-shrink: 0;
      &:not(:last-child) {
        margin-right: 4px;
      }
    }
    .slider-card {
      height: auto;
    }
  }
}
</style>
